import React from 'react'

function work() {
  return (
   <h1>Work in progress</h1>
  )
}

export default work